import { useCallback } from 'react';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/article/pageContext';
import type { UseShareActionsOptions } from '#src/app/shared/hooks/share';

export function useGetShareContent(): UseShareActionsOptions['getContent'] {
	const {
		data: {
			article: { heading },
		},
	} = usePetitionGuidesPageData();

	return useCallback(
		(channel, type, { url }) => {
			switch (channel) {
				case 'twitter':
					return url;
				case 'email':
					if (type === 'title') return heading;
					return url;
				default:
					return '';
			}
		},
		[heading],
	);
}
